import { range } from "lodash"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { ActivityBackground } from "../sprites/ActivitiesBackground"
import { TtAtlas, TtAudio } from "../TobaccoTourAssets"
import { ChewTourState } from "./ChewTourState"
import { SmokelessTourAnimations } from "./SmokelessTourAnimations"
import { SmokelessTourStages } from "./SmokelessTourTypes"

// TODO need to pause on the intro sequence, allow for some time w audio
export class SmokelessTourChewAnimation {
    private static INTRO = "INTRO"
    private static INTRO_END = "INTRO_END"
    private static CHEWING = "CHEWING"
    private static MOUTH_INTRO = "MOUTH_INTRO"
    private static MOUTH = "MOUTH"
    private static MOUTH_EXIT = "MOUTH_EXIT"
    private static SPIT = "SPIT"

    private static readonly FRAME_RATE = 12

    private readonly sprite: Phaser.Sprite

    static play = (
        game: Phaser.Game,
        background: ActivityBackground,
        state: ChewTourState,
    ) => {
        const animation = new SmokelessTourChewAnimation(game)
        const audio = game.add.audio(TtAudio.CHEW_NARRATOR)
        audio.onPlay.addOnce(animation.introAnimation)
        audio.onStop.addOnce(() => {
            animation.sprite.destroy(true)
            background.close()
            state.chew.grayOut()
            state.completed = SmokelessTourStages.CHEW
        })
        audio.play()
    }

    private constructor(private game: Phaser.Game) {
        this.sprite = Sprites.add(game, TtAtlas.CHEW_ANIMATION, {
            debug: true,
            y: Scale.y(0.206),
        })
        Sprites.centerInWorldXOnly(this.sprite)

        this.sprite.animations.add(
            SmokelessTourChewAnimation.INTRO,
            range(25),
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.INTRO_END,
            range(25, 30),
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.CHEWING,
            [30],
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.MOUTH_INTRO,
            range(31, 39),
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.MOUTH,
            [39],
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.MOUTH_EXIT,
            range(40, 48),
            SmokelessTourChewAnimation.FRAME_RATE,
        )
        this.sprite.animations.add(
            SmokelessTourChewAnimation.SPIT,
            [48],
            SmokelessTourChewAnimation.FRAME_RATE,
        )
    }

    private introAnimation = () => {
        const current = this.sprite.animations.play(
            SmokelessTourChewAnimation.INTRO,
        )
        current.onComplete.addOnce(() => {
            const timer = this.game.time.create()
            timer.add(2500, this.introEndAnimation)
            timer.start()
        })
    }

    private introEndAnimation = () => {
        const current = this.sprite.animations.play(
            SmokelessTourChewAnimation.INTRO_END,
        )
        current.onComplete.add(this.chewingAnimation)
    }

    private chewingAnimation = () => {
        this.sprite.animations.play(SmokelessTourChewAnimation.CHEWING)
        const chewing = SmokelessTourAnimations.chewing(
            this.game,
            Scale.x(0.358),
            Scale.y(0.265),
        )
        const current = chewing.animations.play(SmokelessTourAnimations.CHEWING)
        current.onLoop.add(() => {
            if (current.loopCount === 5) {
                current.loop = false
            }
        })
        current.onComplete.addOnce(() => {
            chewing.destroy()
            this.mouthIntroAnimation()
        })
    }

    private mouthIntroAnimation = () => {
        const intro = this.sprite.animations.play(
            SmokelessTourChewAnimation.MOUTH_INTRO,
        )
        intro.onComplete.addOnce(this.mouthAnimation)
    }

    private mouthAnimation = () => {
        this.sprite.animations.play(SmokelessTourChewAnimation.MOUTH)
        const saliva = SmokelessTourAnimations.saliva(
            this.game,
            Scale.x(0.398),
            Scale.y(0.453),
        )
        const current = saliva.animations.play(SmokelessTourAnimations.SALIVA)
        current.onComplete.addOnce(() => {
            saliva.destroy()
            this.mouthExitAnimation()
        })
    }

    private mouthExitAnimation = () => {
        const current = this.sprite.animations.play(
            SmokelessTourChewAnimation.MOUTH_EXIT,
        )
        current.onComplete.addOnce(this.spitAnimation)
    }

    private spitAnimation = () => {
        this.sprite.animations.play(SmokelessTourChewAnimation.SPIT)
        const spitting = SmokelessTourAnimations.spitting(
            this.game,
            Scale.x(0.24),
            Scale.y(0.247),
        )
        const current = spitting.animations.play(
            SmokelessTourAnimations.SPITTING,
        )
        current.onComplete.addOnce(() => {
            spitting.destroy()
            this.swallowAnimation()
        })
    }

    private swallowAnimation = () => {
        const swallowing = SmokelessTourAnimations.swallowing(
            this.game,
            Scale.x(0.416),
            Scale.y(0.587),
        )
        const current = swallowing.animations.play(
            SmokelessTourAnimations.SWALLOWING,
        )
        current.onComplete.addOnce(() => swallowing.destroy())
    }
}
